import React, { Component } from 'react'
import { Select } from '@softwaredev_cegeka/stix-form-select'
import { UserDataContext } from 'src/components/auth/withAuth'

class ImpersonateOrganizationMenu extends Component {
    static contextType = UserDataContext

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            userData: {},
            userOrganizations: {},
        }
    }

    componentDidMount() {
        this.setState({ userData: this.context.data })
        this.loadOrganizations(this.context.data.username)
    }

    loadOrganizations = async username => {
        const { userData } = this.state
        const { apiClient } = this.props

        this.setState({ loading: true })
        if (!userData.is_local_user) {
            try {
                const { data } = await apiClient.fetchTenants(username)
                this.setState(
                    {
                        userOrganizations: data.tenants,
                    },
                    () => this.setDefaultOrganization()
                )
            } catch (ex) {
                this.setState({ userOrganizations: [] })
            } finally {
                this.setState({ loading: false })
            }
        }
    }

    organizationData() {
        return this.state.userOrganizations.map(organization => ({
            value: organization.organization_id,
            label: organization.name,
            id: organization.id,
        }))
    }

    handleOrganizationChange = async chosen => {
        const { apiClient } = this.props

        if (!chosen) {
            try {
                apiClient.updateToken(this.context.authToken)
                let response = await apiClient.deleteImpersonator()
                let permissions = null
                let permissionResponse = await apiClient.fetchAppPermissions(
                    this.context.data.username,
                    null
                )
                const { app_permissions } = permissionResponse.data
                if (!app_permissions || app_permissions.length === 0) {
                    permissions = []
                } else {
                    permissions = app_permissions[0].actions
                }
                this.context.setImpersonatedOrganization(
                    response.headers.authorization,
                    null,
                    permissions
                )
            } catch (e) {
                console.error(e)
            }
        } else {
            try {
                let response = await apiClient.postImpersonator(chosen.value)
                let permissions = null
                let permissionResponse = await apiClient.fetchAppPermissions(
                    this.context.data.username,
                    chosen.value
                )
                const { app_permissions } = permissionResponse.data
                if (!app_permissions || app_permissions.length === 0) {
                    permissions = []
                } else {
                    permissions = app_permissions[0].actions
                }
                this.context.setImpersonatedOrganization(
                    response.headers.authorization,
                    chosen,
                    permissions
                )
            } catch (e) {
                console.error(e)
            }
        }
    }

    setDefaultOrganization = () => {
        const result = this.state.userOrganizations.find(organization => {
            return (
                organization.organization_id ===
                this.context.data.organization_id
            )
        })
        this.handleOrganizationChange({
            value: result.organization_id,
            label: result.name,
            id: result.id,
        })
    }

    renderOrganizationImpersonate() {
        const { userOrganizations } = this.state
        return (
            <>
                {userOrganizations.length > 1 ? (
                    <>
                        <h6>Selected customer</h6>
                        <Select
                            label={'Selected customer'}
                            srOnly
                            options={this.organizationData()}
                            isSearchable
                            isClearable
                            onChange={this.handleOrganizationChange}
                            value={this.context.impersonatedOrganization}
                            placeholder={'Filter Customers'}
                        />
                    </>
                ) : null}
            </>
        )
    }

    render() {
        const { userData } = this.state
        return !userData.is_local_user ? (
            <div className={'organization-menu'}>
                {this.renderOrganizationImpersonate()}
            </div>
        ) : null
    }
}

export default ImpersonateOrganizationMenu
